@if(type && type.toLowerCase() === 'icon') {
  <div>
    <button mat-fab [color]="color$ | async" (click)="onClick()">
      <mat-icon>{{icon}}</mat-icon>
    </button>
  </div>
}
@else if(type && type.toLowerCase() === 'icontext') {
<div>
  <button mat-fab extended [color]="color$ | async" (click)="onClick()">
    <mat-icon>{{icon}}</mat-icon>
    {{title$ | async}}
  </button>
</div>
}
@else if (type && type.toLowerCase() === 'iconsmall') {
<div>
  <button mat-mini-fab [color]="color$ | async" (click)="onClick()">
    <mat-icon>{{icon}}</mat-icon>
  </button>
</div>
}
@else {
<div>
  <button mat-raised-button [color]="color$ | async" (click)="onClick()">
    @if (icon) {
      <mat-icon>{{icon}}</mat-icon>
    }
    {{title$ | async}}
  </button>
</div>
}
